import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {FETCH_VALID_CEQ_TEST_DATE_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../../hooks/query';
import {GET_VALID_CEQ_TEST_DATES_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface ValidCeqTestDateModelResponse {
  firstAcceptedCeqTestDate: string;
  lastAcceptedCeqTestDate: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  registrationExamLevelUuid: string;
  registrationUuid: string;
  onSuccess?: (data: ValidCeqTestDateModelResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled: boolean;
}

export const useGetValidCeqTestDates = ({
                                          registrationExamLevelUuid,
                                          registrationUuid,
                                          onSuccess,
                                          onError,
                                          enabled = false,
                                        }: Input) => {
  const getValidCeqTestDates = async () => {
    const res = await axiosClient.get<ValidCeqTestDateModelResponse>(
        FETCH_VALID_CEQ_TEST_DATE_URL(registrationExamLevelUuid, registrationUuid)
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_VALID_CEQ_TEST_DATES_QUERY_KEY, registrationExamLevelUuid, registrationUuid],
      getValidCeqTestDates,
      {
        onSuccess,
        onError,
        enabled,
      },
      true,
      false
  );
};
